/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Crypto deposit info
 */
export interface CryptoDepositInfoDto {
  /**
   * Asset.
   */
  asset: string;
  /**
   * Network, if applicable.
   */
  network?: string;
  /**
   * Address.
   */
  address: string;
  /**
   * Tag.
   */
  tag?: string;
}
